import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "iconNoText", "iconWithText"];

  connect() {
    this.toggleIcons();
  }

  transliterate(str) {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[œ]/g, "oe")
      .replace(/[æ]/g, "ae");
  }

  clear(e) {
    e.preventDefault();
    this.inputTarget.value = "";
    [...document.querySelectorAll("[role='searchable-group']")].forEach(
      (elm) => (elm.style.display = ""),
    );
    [...document.querySelectorAll("[data-searchable]")].forEach(
      (elm) => (elm.style.display = ""),
    );
    this.toggleIcons();
    this.inputTarget.focus();
  }

  search(e) {
    const searchTerm = this.transliterate(this.inputTarget.value.toLowerCase());
    const items = document.querySelectorAll("[data-searchable]");
    const groups = new Set(
      Array.from(items).map((item) =>
        item.closest("[role='searchable-group']"),
      ),
    );

    items.forEach((item) => {
      const itemText = this.transliterate(
        item.getAttribute("data-searchable").toLowerCase(),
      );
      const matches = itemText.includes(searchTerm);
      item.style.display = matches ? "" : "none";
    });

    groups.forEach((group) => {
      if (group) {
        const groupChildren = Array.from(
          group.querySelectorAll("[data-searchable]"),
        );
        const visibleChildren = groupChildren.filter(
          (item) => item.style.display !== "none",
        );
        group.style.display = visibleChildren.length ? "" : "none";
      }
    });

    this.toggleIcons();
  }

  toggleIcons() {
    const hasText = this.inputTarget.value.length > 0;
    if (hasText) {
      this.iconNoTextTarget.classList.add("hidden");
      this.iconWithTextTarget.classList.remove("hidden");
    } else {
      this.iconNoTextTarget.classList.remove("hidden");
      this.iconWithTextTarget.classList.add("hidden");
    }
  }
}
